import React, { useEffect } from "react";
import { useState } from "react";
import "react-phone-input-2/lib/style.css";
import "./login.css";
import login_img from "../../assets/images/login_img.png";
import eye from "../../assets/images/eye.png";
// import heart1 from "../../assets/images/heart.gif";
// import heart from "../../assets/images/heart2.gif";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../api/api";
import logo from "../../assets/images/logo.png";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import { useForm } from "react-hook-form";
import CustomInput from "../common/Input/Input";
import ReCAPTCHA from "react-google-recaptcha";
import { ReactComponent as Arrow } from "../../assets/images/arrow-left.svg";

const ForgotPassword = () => {
  const [captchaValue, setCaptchaValue] = useState(null);
  const [password, setPassword] = useState(false);
  console.log(password, "password asasas");
  // const [number, setNumber] = useState("");
  const navigate = useNavigate();
  const { doLogin, currUserData } = useAuthContext();

  // console.log(value, otp, "otp");
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleCaptchaChange = (value) => {
    console.log("Captcha Value:", value);
    setCaptchaValue(value);
  };
  const handlelogin = async (data) => {
    console.log(data, "form");

    var payload = {
      email: data.email,
    };

    let res = await api(
      `api/v1/auth/forgot-password`,
      payload,
      "postWithoutToken",
      "",
      "Otp Send Successfully"
    );
    if (res && res.success) {
      // setSubscriptionData(res?.data);
      // console.log(res.data, res, "card");
      navigate(`/change-password?email=${encodeURIComponent(data.email)}`);
    }
  };
  const registerOptions = {
    email: {
      required: "Email is required",
      pattern: {
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: "Enter a valid email address",
      },
    },
  };

  return (
    <>
      <div className="loginModal">
        <div className="container-fluid">
          <div className="row">
            <div className="login_left">
              <div className="images">
                <img src={login_img} />
              </div>
            </div>
            <div className="login_reight">
              <div className="login-content">
                <div>
                  <img src={logo} alt="" />
                </div>

                <form className="w-100" onSubmit={handleSubmit(handlelogin)}>
                  <h6>
                    <span onClick={() => navigate(-1)}>
                      <Arrow />
                    </span>
                    {/* <img src={Arrow} /> */}
                    Forgot Password
                  </h6>
                  <CustomInput
                    register={register}
                    label="Please enter your email to reset it."
                    name="email"
                    placeholder="e.g., classhila@gmail.com"
                    type="text"
                    errors={errors.email}
                    validation={registerOptions.email}
                  />

                  <button
                    className="mx-auto d-block btn_primary w-100 mb-5 mt-5" // onClick={() => navigate("/dashboard")}
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
